import { BackboneSelectionTable } from "lib/common/selectiontable/SelectionTable";
import PropTypes from "prop-types";
import React from "react";

export default class DataQualityResults extends React.Component {
    // REPORT_TYPE_SUMMARY: 's'
    // REPORT_TYPE_DETAIL: 'd'

    // VALIDATION_TYPE_ILLEGAL_AND_WARNING: 'iw'
    // VALIDATION_TYPE_ILLEGAL: 'i'
    // VALIDATION_TYPE_WARNING: 'w'
    render() {
        return <BackboneSelectionTable {...this.props}/>;
    }
}

DataQualityResults.propTypes = {
    collection: PropTypes.instanceOf(Backbone.Collection),
    fields: PropTypes.instanceOf(Backbone.Collection),
    hasStereotype: PropTypes.bool.isRequired,
    reportTypeKey: PropTypes.string.isRequired,
    onRecordSelection: PropTypes.func,
    onSort: PropTypes.func.isRequired
};




// WEBPACK FOOTER //
// ./app/lib/dqr/views/results/DataQualityResults.js